import React from "react"
import ImageBanner from "../components/ImageBanner"
import {RoundelGrid} from "../components/RoundelGrid"
import styled from "styled-components"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {useFeaturedCategoriesQuery, useStoreBannersQuery, useStoreDepartmentsQuery} from "@irati/payrollpay/hooks"
import Spinner from "@irati/ui/src/Loading/Spinner"
import {StoreHomeEmployeeOrganisation} from "@irati/types"
import {transformToRoundels} from "../utils/roundels"
import {useStoreContext} from "../context/StoreContext"

const PayrollPayLandingScreen = () => {
  const theme = useTheme()
  const {schemeType} = useStoreContext()

  const scheme = {
    organisationId: "1757-perkbox-bridge-org",
    schemeType
  }
  const {data: banners, load: bannersLoading} = useStoreBannersQuery(scheme, {
    fetchPolicy: "cache-and-network"
  })

  const {data: featuredCategories, load: featuredCategoriesLoading} = useFeaturedCategoriesQuery(scheme, {
    fetchPolicy: "cache-and-network"
  })

  const {data: departmentsData, load: departmentsLoading} = useStoreDepartmentsQuery(scheme, {
    fetchPolicy: "cache-and-network"
  })

  const loading = bannersLoading?.loading || featuredCategoriesLoading?.loading || departmentsLoading?.loading

  if (loading) {
    return <Spinner />
  }

  const trending = transformToRoundels(
    (featuredCategories as unknown as StoreHomeEmployeeOrganisation)?.employeeOrganisation?.scheme?.featuredCategories || []
  )
  const departments = transformToRoundels(
    (departmentsData as unknown as StoreHomeEmployeeOrganisation)?.employeeOrganisation?.scheme?.store?.departments || []
  )

  return (
    <>
      <ImageBanner
        mobileBannerUrl={
          (banners as unknown as StoreHomeEmployeeOrganisation)?.employeeOrganisation?.scheme?.banners?.[0]?.mobileImageUrl ?? ""
        }
        desktopBannerUrl={
          (banners as unknown as StoreHomeEmployeeOrganisation)?.employeeOrganisation?.scheme?.banners?.[0]?.desktopImageUrl ?? ""
        }
      />

      <RoundelGrid roundels={trending} title="Trending" roundelBackgroundColor={theme.colors.greys.grey03} />

      <Section>
        <RoundelGrid roundels={departments} title="Departments" />
      </Section>
    </>
  )
}

export default PayrollPayLandingScreen

const Section = styled.div`
  width: 100%;
  background-color: ${({theme}) => theme.colors.greys.grey03};
`
